import React, { useEffect, useState } from "react";
import {
  createSearch,
  deleteSearch,
  getCategory,
  updateSearch,
  addFile,
  getUrl
} from "../../services/Admin/adminServices";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Modal, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import Pagination from "../components/Pagination";
import Spinner from "../components/Common/Spinner";
import { debounce } from "lodash";

// 🌟 Helper component to handle async image URLs
const AsyncImage = ({ imgKey, alt, style }) => {
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchImage = async () => {
      if (!imgKey) return;
      try {
        const urlRes = await getUrl(imgKey);
        const finalUrl = urlRes?.data?.data;
        if (isMounted) setImgSrc(finalUrl);
      } catch (error) {
        console.error("Failed to load image:", error);
      }
    };

    fetchImage();
    return () => {
      isMounted = false;
    };
  }, [imgKey]);

  if (!imgSrc) {
    return (
      <div style={{ ...style, backgroundColor: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <small className="text-muted">Loading...</small>
      </div>
    );
  }

  return <img src={imgSrc} alt={alt} style={style} />;
};


const Subjects = () => {
  const [service, setService] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [imageLoading, setImageLoading] = useState(false)
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState("");

  // 🌟 NEW: State for Confirmation Modal
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const navigate = useNavigate();

  const getUrlImage = async (img) => {
    try {
      const res = await getUrl(img);
      // Ensure we return the actual URL string from your API response
      return res?.data?.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getCatogoryData = async () => {
    try {
      setLoading(true);
      const response = await getCategory(currentPage, 10, debouncedSearch);
      setService(response?.data?.data?.data);
      setTotalItems(response?.data?.data?.total);
    } catch (error) {
      console.error("errors", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch the URL when opening the Edit Modal
  const handleView = async (serviceItem) => {
    setSelectedService(serviceItem);
    setShowModal(true);

    if (serviceItem.image) {
      try {
        setImageLoading(true)
        const resolvedUrl = await getUrlImage(serviceItem.image);
        setPreview(resolvedUrl || "");
      } catch (error) {
        console.error(error)
      } finally {
        setImageLoading(false)
      }
    } else {
      setPreview("");
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedService(null);
    setPreview("");
  };

  // 🌟 NEW: Trigger the confirmation modal
  const promptDelete = (id) => {
    setItemToDelete(id);
    setShowConfirmModal(true);
  };

  // 🌟 NEW: Execute the delete after confirmation
  const confirmDelete = async () => {
    if (!itemToDelete) return;
    try {
      await deleteSearch(itemToDelete);
      setService((prev) => prev.filter((s) => s._id !== itemToDelete));
      setTotalItems((prev) => prev - 1);
      toast.success("Deleted successfully");
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.error("error-> ", error);
    } finally {
      setShowConfirmModal(false);
      setItemToDelete(null);
    }
  };

  // 🌟 NEW: Close the confirmation modal without deleting
  const cancelDelete = () => {
    setShowConfirmModal(false);
    setItemToDelete(null);
  };

  const handleFileUpload = async (e, fieldName, setFieldValue) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      const res = await addFile(formData);

      if (res) {
        setPreview(URL.createObjectURL(file));
        setFieldValue("image", res?.data?.data?.fileUrl || res?.data?.fileUrl);
      }
    } catch (error) {
      toast.error("File upload failed");
      setPreview("");
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    const handler = debounce(() => {
      setDebouncedSearch(search.trim());
    }, 500);

    handler();
    return () => handler.cancel();
  }, [search]);

  const boxColors = [
    "#2697CD", "#F0B01D", "#699B4C", "#976EBC", "#D07353", "#ECD5A1", "#C8DBD7"
  ];

  const getRandomColor = () => {
    const randomIndex = Math.floor(Math.random() * boxColors.length);
    return boxColors[randomIndex];
  };

  useEffect(() => {
    getCatogoryData();
  }, [currentPage, debouncedSearch]);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Title is required"),
  });

  const initialFormValues = {
    name: "",
    image: "",
  };

  return (
    <div>
      <h1 style={{ color: "#64CAE5" }}>Category</h1>
      <div className="pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-center mb-4">
        <div className="flex-grow-1">
          <input
            type="text"
            style={{ borderRadius: "0.5rem", borderColor: "#64CAE5" }}
            className="form-control w-100"
            placeholder="Search....."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <button
            className="btn"
            style={{
              backgroundColor: "#64CAE5",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "4px",
              marginBottom: "4px",
            }}
            onClick={() => setShowModal(true)}
          >
            Add new
          </button>
        </div>
      </div>

      {loading ? (
        <Spinner />
      ) : service.length === 0 ? (
        <p>No category available.</p>
      ) : (
        <div className="row">
          {service.map((serviceItem, index) => (
            <div className="col-md-3 mb-4" key={serviceItem._id || index}>
              <div
                style={{
                  backgroundColor: getRandomColor(),
                  borderRadius: "12px",
                }}
                className={`card shadow-lg card-custom position-relative`}
              >
                <div className="card-body d-flex justify-content-between align-items-start">
                  <div className="d-flex justify-content-between gap-5">


                    {serviceItem.image && (
                      <div className="mb-2 ">
                        <AsyncImage
                          imgKey={serviceItem.image}
                          alt={serviceItem.name}
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    )}

                    <div className="d-flex align-items-center">
                      <h5 className="card-title ">{serviceItem.name}</h5>
                    </div>
                  </div>
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      id={`dropdown-basic-${index}`}
                      style={{ padding: "4px 8px" }}
                    >
                      {svg1}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleView(serviceItem)}>
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => navigate(`/vendors?category=${serviceItem?._id}`)}>
                        Vendors
                      </Dropdown.Item>
                      {/* 🌟 MODIFIED: Trigger confirmation instead of immediate delete */}
                      <Dropdown.Item onClick={() => promptDelete(serviceItem._id)}>
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="card-footer clearfix">
        <div className="d-flex justify-content-between align-items-center">
          <div className="dataTables_info" style={{ color: "#64CAE5" }}>

          </div>
          <div className="d-flex align-items-center" style={{ gap: "10px" }}>
            <Pagination
              pageCount={totalPages}
              pageValue={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#64CAE5" }}>
            {selectedService ? "Edit Category" : "Add New Category"}
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={selectedService || initialFormValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={async (values, { setSubmitting }) => {
            try {
              if (selectedService) {
                const payload = {
                  id: values._id,
                  name: values.name,
                  image: values.image,
                };
                await updateSearch(payload);
                toast.success("Updated successfully");
              } else {
                const payload = {
                  name: values.name,
                  image: values.image,
                };
                await createSearch(payload);
                toast.success("Added successfully");
              }
              handleClose();
              getCatogoryData();
            } catch (error) {
              toast.error("Something went wrong");
              console.error(error);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, setFieldValue }) => (
            <FormikForm>
              <Modal.Body>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontSize: "14px", fontWeight: "500" }}>
                    Title
                  </Form.Label>

                  <Field
                    name="name"
                    className="form-control"
                    placeholder="ex. Barber"
                    style={{ borderColor: "#64CAE5" }}
                  />
                  <ErrorMessage name="name" component="div" className="text-danger" />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label style={{ fontSize: "14px", fontWeight: "500" }}>
                    Category Image
                  </Form.Label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    onChange={(e) => handleFileUpload(e, "image", setFieldValue)}
                    style={{ borderColor: "#64CAE5" }}
                    disabled={uploading}
                  />
                  {uploading && <small className="text-info">Uploading image...</small>}

                  {
                    imageLoading ? <div>Loading...</div> :
                      preview && (
                        <div className="mt-3">
                          <p className="mb-1 text-muted" style={{ fontSize: "14px" }}>Preview:</p>
                          <img
                            src={preview}
                            alt="Category Preview"
                            style={{
                              width: "120px",
                              height: "120px",
                              objectFit: "cover",
                              borderRadius: "8px",
                              border: "1px solid #ddd"
                            }}
                          />
                        </div>
                      )
                  }
                  <ErrorMessage name="image" component="div" className="text-danger" />
                </Form.Group>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  type="submit"
                  disabled={isSubmitting || uploading}
                  style={{ backgroundColor: "#64CAE5", border: "none" }}
                >
                  {selectedService ? "Update" : "Add"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      {/* 🌟 NEW: Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={cancelDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this category? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default Subjects;